export default "__VITE_ASSET__BKvdFjSc__"